import { ItemList } from '../orm'

class UserList extends ItemList {
    getEntityKey() {
        return "user"
    }
}

export const userList = new UserList("user__default")
